export default "__VITE_ASSET__11a19a0f__"